// ============================================================
// Navbar.js - Top navigation bar
// ============================================================
import React, { useState } from "react";
import { NAV_LINKS } from "../data";

function Navbar() {
  const [activeNav, setActiveNav] = useState("Home");

  return (
    <div>

      <div className="top-bar">
        <div className="top-bar-left">
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            9476051755
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            Whaniportblair@gmail.com
          </span>
        </div>
        <div className="top-bar-right">
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            Prothrapur, Port Blair, South Andaman – 744 105
          </span>
        </div>
      </div>

      <nav className="navbar">

        <div className="navbar-logo">
          <img src="/logo.jpeg" alt="WHANI Logo" className="logo-image" />
          <div className="logo-text">
            <h1>WHANI</h1>
            <p>We Help Andaman &amp; Nicobar<br />Islands</p>
          </div>
        </div>

        <ul className="nav-links">
          {NAV_LINKS.map((link) => (
            <li key={link}>
              <a
                href={"#" + link.toLowerCase().replace(/\s+/g, "-")}
                className={activeNav === link ? "active" : ""}
                onClick={() => setActiveNav(link)}
              >
                {link}
              </a>
            </li>
          ))}
          <li>
            <a href="#contact" className="btn-contact">
              Contact us
            </a>
          </li>
        </ul>

      </nav>

    </div>
  );
}

export default Navbar;
